import type { TabKey } from "../types";

/** Hash → tab. Anything unrecognised lands on the chat home. */
const BY_HASH: Record<string, TabKey> = {
  "#ask": "ask",
  "#leave": "leave",
  "#payslips": "payslips",
  "#sick-leave": "sick",
  "#telegram": "telegram",
};

const TABS: Array<{ key: TabKey; hash: string; label: string }> = [
  { key: "ask", hash: "#ask", label: "Ask HR" },
  { key: "leave", hash: "#leave", label: "Leave" },
  { key: "payslips", hash: "#payslips", label: "Payslips" },
  { key: "sick", hash: "#sick-leave", label: "Sick Leave" },
  { key: "telegram", hash: "#telegram", label: "Telegram" },
];

export function tabFromHash(): TabKey {
  return BY_HASH[location.hash] ?? "ask";
}

export function hashForTab(key: TabKey): string {
  return TABS.find((t) => t.key === key)!.hash;
}

export function Tabs({ active }: { active: TabKey }) {
  return (
    <nav className="tabs" aria-label="Portal sections">
      {TABS.map((t) => (
        <a key={t.key} href={t.hash} className={t.key === active ? "active" : undefined}>
          {t.label}
        </a>
      ))}
    </nav>
  );
}
